<app-cabecalho-direita [data]="data.CABECALHO"></app-cabecalho-direita>

<section id="beneficios">
    <app-beneficio-completo *ngFor="let beneficio of data.BENEFICIOS; let index = index" [data]="beneficio"></app-beneficio-completo>
</section>